export default __webpack_public_path__ + "static/media/socdem.5c01b7f7.svg";